module.exports = __webpack_public_path__ + "static/media/img_mockup@2x.c17b57c1.png";